import React, { useState, useContext, useEffect } from "react";
import companyBasedRequest from "../../../request/companyBasedRequest";
import translations from "../../../translations/translations";
import "./shopContactModal.css";
import { CombinedContext } from "../../../context/combinedContext";
import PhoneInput from "../../common/phoneInput/phoneInput";
import { Phone, Share2 } from "lucide-react";

const ShopContactModal = ({ open, onClose, shopData, setShopData }) => {
	const { language, setUserData, userData } = useContext(CombinedContext);

	const [localData, setLocalData] = useState({
		phone: "",
		email: "",
		website: "",
		instagram: "",
		facebook: "",
		tiktok: "",
	});

	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (shopData) {
			setLocalData({
				phone: shopData.phone || "",
				email: shopData.email || "",
				website: shopData.socialLinks?.website || "",
				instagram: shopData.socialLinks?.instagram || "",
				facebook: shopData.socialLinks?.facebook || "",
				tiktok: shopData.socialLinks?.tiktok || "",
			});
		}
	}, [shopData]);

	if (!open) return null;

	const handleSave = async () => {
		const updateData = {
			phone: localData.phone,
			email: localData.email,
			socialLinks: {
				website: localData.website,
				instagram: localData.instagram,
				facebook: localData.facebook,
				tiktok: localData.tiktok,
			},
		};

		// ✅ Update frontend immediately

		// ✅ Send to backend
		try {
			setSaving(true);
			const res = await companyBasedRequest.updateShopContactInfo(shopData.shopId, updateData, userData.cognitoTokens.AccessToken);
			setUserData((prev) => ({ ...prev, shop: res.shop }));
			setShopData((prev) => ({
				...prev,
				phone: updateData.phone,
				email: updateData.email,
				socialLinks: updateData.socialLinks,
			}));
		} catch (err) {
			console.error("Failed to update shop contact info:", err);
		} finally {
            setSaving(false);
        }

		onClose();
	};

	return (
		<div className="sf-book-overlay" onClick={onClose}>
			<div className="sf-book-modal" onClick={(e) => e.stopPropagation()}>
				{/* HEADER */}
				<div className="sf-profile-modal-header">
					<h2 className="sf-profile-modal-title">{translations[language].profile.sidebar.contact.title}</h2>
					<button className="sf-book-close" onClick={onClose}>
						✕
					</button>
				</div>

				{/* BODY */}
				<div className="sf-book-body">
					{/* CONTACT SECTION */}
					<div className="sf-box">
						<h3 className="sf-shopinfo-section-title">
							<Phone size={18} strokeWidth={1.6} className="sf-shopinfo-icon" />
							{translations[language].profile.sidebar.contact.title}
						</h3>

						<PhoneInput businessPhone={localData.phone} setBusinessPhone={(val) => setLocalData({ ...localData, phone: val })} />

						<input
							className="sf-book-input"
							type="email"
							placeholder="Email"
							value={localData.email}
							onChange={(e) => setLocalData({ ...localData, email: e.target.value })}
						/>
					</div>

					{/* SOCIAL SECTION */}
					<div className="sf-box">
						<h3
							style={{
								display: "flex",
								alignItems: "center",
								gap: "6px",
							}}
						>
							<Share2 size={18} strokeWidth={1.6} />
							{translations[language].profile.sidebar.contact.social || "Social Media"}
						</h3>
						<input
							className="sf-book-input"
							placeholder="Website"
							value={localData.website}
							onChange={(e) => setLocalData({ ...localData, website: e.target.value })}
						/>
						<input
							className="sf-book-input"
							placeholder="Instagram"
							value={localData.instagram}
							onChange={(e) => setLocalData({ ...localData, instagram: e.target.value })}
						/>
						<input
							className="sf-book-input"
							placeholder="Facebook"
							value={localData.facebook}
							onChange={(e) => setLocalData({ ...localData, facebook: e.target.value })}
						/>
						<input
							className="sf-book-input"
							placeholder="TikTok"
							value={localData.tiktok}
							onChange={(e) => setLocalData({ ...localData, tiktok: e.target.value })}
						/>
					</div>
				</div>

				{/* FOOTER */}
				<div className="sf-base-footer">
					<button className="btn ghost" onClick={onClose}>
						{translations[language].calendar.editor.cancel}
					</button>
					<button className="btn" onClick={handleSave} disabled={saving}>
						{saving ? translations[language].calendar.editor.saving : translations[language].calendar.editor.save}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ShopContactModal;
